export default __webpack_public_path__ + "static/media/dt_title.16e3ac82.gif";